function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M.3 1.1v509.4h826V1.1H.4"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffd00e",
  d: "M809.2 493.3H17.5v-475h791.7v475"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#174385",
  d: "M620 113.2c-38.9 0-69.7 17.6-77.7 48.6-8-31-38.9-48.6-77.6-48.6-35.3 0-64 14.5-75 40.4-11-26-39.6-40.4-74.8-40.4-45.3 0-79.7 23.9-79.7 65.3 0 10.4 2.2 19.6 6.2 27.7l-1.5.7a69.8 69.8 0 0 1-27.2 5c-20.5 0-38.9-12.9-38.9-32.8 0-21.5 15.8-34.4 36.3-34.4 6.3 0 11.8.7 16.9 2.1 0 0 5.4-14.4 18.8-25.2l-4-1.7a92.5 92.5 0 0 0-37.2-6.7c-45.2 0-79.7 23.9-79.7 65.3 0 41 34.5 65 79.7 65 12 0 25.3-1.7 36.7-5 4.2-1 14.3-4.4 21.6-8.7a95.5 95.5 0 0 0 52 13.7c35.2 0 63.9-14.6 74.9-40.4 11 25.8 39.6 40.4 74.9 40.4 36 0 65.1-15.2 75.5-42.1v75.3H589v-37.5c9.5 2.8 20 4.3 31 4.3 45.2 0 79.7-24 79.7-65 0-41.4-34.5-65.3-79.7-65.3zM314.8 213.3c-21.9 0-30.8-16.4-30.8-34.8 0-18.7 9-35.2 30.8-35.2s30.7 16.5 30.7 35.2c0 18.4-9 34.8-30.7 34.8zm149.8 0c-21.9 0-30.8-16.4-30.8-34.8 0-18.7 9-35.2 30.8-35.2s30.7 16.5 30.7 35.2c0 18.4-9 34.8-30.7 34.8zm155.2 0c-21.8 0-30.8-16.4-30.8-34.8 0-18.7 9-35.2 30.8-35.2s30.8 16.5 30.8 35.2c0 18.4-9 34.8-30.8 34.8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M794.2 478.4H31.9V318.6h762.3v159.8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M191.6 415.5a13 13 0 0 0 13.3 13.3c4.3 0 8.2-2 10.2-6h25.7c-4.6 16.9-21.7 22.5-37.5 22.5-21.8 0-38.7-12.5-38.7-35.3 0-22.3 16.8-36.5 38.5-36.5 25.2 0 40.3 17.3 40 42zm24.5-13.8c0-6.2-5.6-11.8-12-11.8-8 0-12.5 4.6-12.5 11.8h24.5M252.5 443.3V350h27v93.3h-27M316 415.5a13 13 0 0 0 13.4 13.3c4.2 0 8.1-2 10-6h25.9c-4.7 16.9-21.8 22.5-37.6 22.5-21.8 0-38.6-12.5-38.6-35.3 0-22.3 16.7-36.5 38.4-36.5 25.2 0 40.4 17.3 40 42zm24.5-13.8c0-6.2-5.6-11.8-12-11.8-8 0-12.5 4.6-12.5 11.8h24.5M405.3 424.3v19h-27V350h27v46.2l17.2-20.8H454l-25 26.3 28.4 41.6H425l-14.5-24-5 5M506.4 443.3c-35.4 2-39.7-.5-39.7-24V391h-9.6v-15.6h10v-21.1h26.6v21.1h13V391h-13v24.6c0 6.2.9 8.4 8.4 8.4h4.3v19.3M522.2 375.4h24.5v13.8h.3c3.7-10.7 10.3-15.7 20.8-15.7 1.2 0 2.4.2 3.5.4v27c-1.8-.3-3.7-.9-5.6-.9-11 0-16.5 5.2-16.5 19.9v23.4h-27v-67.9M616.3 373.5c24 0 38.8 14.1 38.8 35.2 0 24.9-16.9 36.6-38.7 36.6-21.7 0-38.6-12-38.6-35.2 0-23.5 15.6-36.6 38.5-36.6zm-11.5 35.2c0 12.9 4.8 18.4 11.6 18.4 7.3 0 11.7-5.5 11.7-18.4 0-10-4.4-17.5-11.4-17-9.2 0-12 9.4-12 17"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    shaperendering: "geometricPrecision",
    viewBox: "0 0 827 512"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/coop-elektro.8f40f6ba.svg";
export { SvgComponent as ReactComponent };